// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_9e1425b4d3--tooltip--slBfg","arrow":"_9e1425b4d3--arrow--wuhV1"};